import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

const FACTS = [
  ['Wykształcenie', ['Ekonomistka', 'Filolożka języka rosyjskiego', 'Doradczyni zawodowa']],
  ['Doświadczenie', ['25 lat w kształceniu zawodowym', 'Manager kształcenia zawodowego w Fabryce Mebli WERSAL', 'Trenerka ORE MENiS z doradztwa zawodowego']],
  ['Inicjatywy', ['Szkółka tapicerska Livello sofa', 'Wersal School', 'Przedsiębiorcze dzieciaki']],
];

function About() {
  return (
    <>
      <Helmet>
        <title>O nas – Monika Józefowska | SIGMA</title>
        <meta name="description" content="Monika Józefowska – ekonomistka i doradczyni zawodowa z 25-letnim doświadczeniem w kształceniu zawodowym, autorka SIGMY." />
      </Helmet>

      <section className="pub-section">
        <div className="pub-wrap pub-author pub-author--wide">
          <img src="/about.jpg" alt="Monika Józefowska, autorka SIGMY" style={{ width: '100%', maxWidth: 300, borderRadius: 8 }} />
          <div>
            <div className="pub-kicker">O nas</div>
            <h1 className="pub-h1">Monika Józefowska</h1>
            <p className="pub-lead">
              Ekonomistka, manager oświaty i doradczyni zawodowa. Od 25 lat zajmuje się kształceniem zawodowym:
              uczyła teoretycznej nauki zawodu i współtworzyła programy szkoleniowe dla przyszłych fachowców.
              Obecnie jest managerem kształcenia zawodowego w Fabryce Mebli WERSAL.
            </p>
            <p className="pub-muted">
              Przez lata widziała z bliska, ile nieporozumień między pracodawcą a pracownikiem bierze się z prostych
              rzeczy: ile dni urlopu zostało, kto i kiedy prosił o wolne, czy wniosek został przyjęty. SIGMA powstała,
              żeby te sprawy były uporządkowane i przejrzyste dla obu stron.
            </p>
            <p className="pub-muted">
              Zajrzyj też do{' '}
              <a href="https://akademiafachowca.edu.pl" target="_blank" rel="noopener noreferrer" className="pub-link">
                Akademii Fachowca
              </a>
              {' '}— platformę z kursami i materiałami dla fachowców.
            </p>
          </div>
        </div>
      </section>

      <section className="pub-section pub-section--alt">
        <div className="pub-wrap">
          <h2 className="pub-h2">Doświadczenie</h2>
          <div className="pub-grid-3" style={{ marginTop: 28 }}>
            {FACTS.map(([title, items]) => (
              <div key={title}>
                <h3 className="pub-h3">{title}</h3>
                <ul className="pub-list">
                  {items.map(item => <li key={item} className="pub-muted">{item}</li>)}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="pub-section">
        <div className="pub-wrap pub-split" style={{ alignItems: 'start' }}>
          <div>
            <div className="pub-kicker">Nasza zasada</div>
            <h2 className="pub-h2">„Ignorantia iuris nocet”</h2>
            <p className="pub-muted">Nieznajomość prawa szkodzi. Kto nie wie, ten traci: czas, pieniądze i dobrą atmosferę w zespole.</p>
          </div>
          <div>
            <h3 className="pub-h3">Dlaczego SIGMA jest dla pracodawców</h3>
            <p className="pub-muted">
              Właściciel małej firmy nie ma działu kadr. Wnioski urlopowe na kartkach i w SMS-ach łatwo zgubić,
              a pomyłka w puli urlopowej kończy się nieporozumieniem albo kłopotem przy rozliczeniu.
              SIGMA zbiera wnioski w jednym miejscu, liczy pulę i pokazuje kalendarz urlopów całej firmy.
            </p>
            <h3 className="pub-h3" style={{ marginTop: 28 }}>I dla ich pracowników</h3>
            <p className="pub-muted">
              Pracownik w każdej chwili sprawdza, ile ma urlopu, i składa wniosek z telefonu. Dla niego SIGMA jest bezpłatna.
            </p>
            <div className="pub-actions" style={{ marginTop: 28 }}>
              <Link to="/register?type=employer" className="pub-btn">Wypróbuj bezpłatnie</Link>
              <Link to="/contact" className="pub-link">Napisz do nas</Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default About;
